export default __webpack_public_path__ + "static/media/ofertIconBlue.dc001b8b.svg";